// src/components/passkey/PasskeySetupDialog.js

import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  makeStyles,
} from "@material-ui/core";
import SecurityIcon from "@material-ui/icons/Security";
import FingerprintIcon from "@material-ui/icons/Fingerprint";
import { setSkipPasskeyReminder, redirectToPasskeySetup } from "../../utils/passkeyUtils";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  securityIcon: {
    fontSize: 60,
    color: "#013a80",
    marginBottom: theme.spacing(2),
  },
  setupButton: {
    backgroundColor: "#013a80",
    color: "white",
    "&:hover": {
      backgroundColor: "#012d66",
    },
  },
}));

/**
 * Dialog component for prompting users to set up passkey authentication
 * @param {boolean} open - Whether dialog is open
 * @param {function} onClose - Callback when user closes dialog
 * @param {function} onSetup - Optional callback before redirecting to setup (for analytics, etc.)
 */
const PasskeySetupDialog = ({ open, onClose, onSetup }) => {
  const classes = useStyles();
  const [dontRemind, setDontRemind] = useState(false);

  const handleLater = () => {
    if (dontRemind) {
      setSkipPasskeyReminder(true);
    }
    onClose();
  };

  const handleSetup = () => {
    if (onSetup) {
      onSetup();
    }
    redirectToPasskeySetup();
  };

  return (
    <Dialog 
      open={open} 
      onClose={() => {}} // Prevent closing by clicking outside
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box display="flex" flexDirection="column" alignItems="center">
          <SecurityIcon className={classes.securityIcon} />
          <Typography variant="h6" align="center">
            Set Up Passkey for Enhanced Security
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="body1" align="center">
          We detected that you haven't set up a passkey yet. Passkeys provide a more secure and convenient way to sign in.
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          With passkeys, you can sign in using your fingerprint, face recognition, or device PIN instead of a password.
        </Typography>
        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={dontRemind}
                onChange={(e) => setDontRemind(e.target.checked)}
                color="primary"
              />
            }
            label="Don't remind me again"
          />
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '16px 24px', justifyContent: 'space-between' }}>
        <Button onClick={handleLater} color="default">
          Later
        </Button>
        <Button 
          onClick={handleSetup} 
          variant="contained" 
          className={classes.setupButton}
          startIcon={<FingerprintIcon />}
        >
          Set Up Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasskeySetupDialog;